/**
 * NOTE: This component duplicates the component at /components/products/ProductCard/ProductCard.tsx
 *
 * The other version should be used when these two components are unified.
 */

import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";

import { BrandCatalogProduct } from "api/requests/getProductCatalog";
import currencyFormatter from "common/currencyFormatter";
import { getCountryCode } from "redux/selectors/location";

import StarRating from "components/botanic/StarRating";
import Image from "components/Image";

type Props = {
  product: BrandCatalogProduct;
  className?: string;
};

const ProductCard = ({ product, className }: Props) => {
  const countryCode = useSelector(getCountryCode);

  return (
    <a
      className={classNames(
        "elevation-low rounded overflow-hidden p-lg pt-xl",
        className
      )}
      href={`/brands/${product.brand.slug}/products/${product.slug}`}
    >
      <div>
        <div className="p-0 mx-auto" style={{ width: "112px" }}>
          {(product.thumbnailImageUrl || product.imageUrl) && (
            <Image
              src={
                product.thumbnailImageUrl
                  ? product.thumbnailImageUrl
                  : product.imageUrl
              }
              sizes={[112]}
              className="mb-md"
              alt={`Product image for ${product.name}`}
              ratio="square"
            />
          )}
        </div>
        <div className="text-secondary text-xs leading-none mb-xs">
          {product.subcategoryName
            ? product.subcategoryName
            : product.categoryName}
        </div>
        <h3 className="font-bold text-sm truncate-lines truncate-2-lines">
          {product.name}
        </h3>
        {!!product.avgApprovedPublicReviewRating && (
          <StarRating
            rating={product.avgApprovedPublicReviewRating}
            ratingCount={product.countApprovedPublicReviews}
            showRating={true}
            starWidth={14}
            className="my-xs"
          />
        )}
      </div>
      {!!product.bestOfferVariant && (
        <div className="mt-xs text-xs font-bold text-grey">
          Starting at
          <div className="text-sm font-bold text-default">
            {currencyFormatter(product.bestOfferVariant.price, countryCode)}
          </div>
        </div>
      )}
    </a>
  );
};

export default ProductCard;
